/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import ContentPanel from 'components/common/ContentPanel';
import Text from 'components/common/Text';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';

const MissingInvitationTemplate = () => (
  <ContentPanel titlePhrase={{ id: 'groupUserInviteInvalid.title.text' }}>
    <WhiteCardWithWidePadding>
      <Text size="body">
        <pre>
          <FormattedMessage id="groupUserInviteInvalid.message.text" />
        </pre>
      </Text>
    </WhiteCardWithWidePadding>
  </ContentPanel>
);

export default MissingInvitationTemplate;
